import { defineFormConfig } from "@src/components/business-form";
import type { ActOfCheckingAvailabilityFactQtyByStorePlaceData } from "../../../../../../api/actOfCheckingAvailability";

/** Значение фактического количества по ячейке в форме инвентаризации. */
export interface StockPartialInventoryFactQtyByStorePlaceFormValues {
    /** Код ячейки места хранения. */
    spCode: number;
    /** Текст ячейки для динамического label поля. */
    cellText: string;
    /** Фактическое количество в ячейке. */
    factQty: number;
}

/** Значения формы инвентаризации строки АПН. */
export interface StockPartialInventoryContentFormValues {
    /** Суммарное фактическое количество по строке. */
    factQty: number;
    /** Фактические количества по местам хранения. */
    factQtyByStorePlaces: StockPartialInventoryFactQtyByStorePlaceFormValues[];
}

/** Доменная часть формы инвентаризации без кода строки АПН. */
export interface StockPartialInventoryContentFormDomain {
    /** Суммарное фактическое количество по строке. */
    factQty: number;
    /** Фактические количества по местам хранения, если партия хранится в ячейках. */
    factQtyByStorePlaces?: ActOfCheckingAvailabilityFactQtyByStorePlaceData[];
}

/** Конфигурация формы инвентаризации строки АПН. */
export const stockPartialInventoryContentFormConfig = defineFormConfig<
    StockPartialInventoryContentFormValues,
    StockPartialInventoryContentFormDomain
>({
    fields: {
        factQty: {
            type: "number",
            label: "Фактическое количество",
            default: 0,
            validation: { required: true, min: 0 },
            map: "factQty",
        },
        factQtyByStorePlaces: {
            type: "array",
            label: "Фактический остаток по местам хранения",
            default: [],
            map: "factQtyByStorePlaces",
            itemFields: {
                factQty: {
                    type: "number",
                    label: (item) => `Кол-во факт в ячейке ${item.cellText}`,
                    validation: { required: true, min: 0 },
                    map: "factQty",
                },
            },
        },
    },
    toDomainOverride: (values) => {
        if (values.factQtyByStorePlaces.length === 0) {
            return {
                factQty: values.factQty,
            };
        }

        const factQtyByStorePlaces = values.factQtyByStorePlaces.map((item) => ({
            spCode: item.spCode,
            factQty: item.factQty,
        }));

        return {
            factQty: factQtyByStorePlaces.reduce((sum, item) => sum + item.factQty, 0),
            factQtyByStorePlaces,
        };
    },
});
